export default {
  getDrawer(state) {
    return state.drawer;
  },
  getExtendedSearch(state) {
    return state.extended_search;
  },
  getDropdownDataAPI(state) {
    return state.dropDownData;
  },
  getDeliveryDirectMailFlagGetters(state) {
    // console.log(state.directMailDeliveryBoxFlag, 90);
    return state.directMailDeliveryBoxFlag;
  },
  getEmailElectronicTypeBoxFlagGetters(state) {
    // console.log(state.emailElectronicTypeBoxFlag, 90);
    return state.emailElectronicTypeBoxFlag;
  },
  getprintPublicationTypeBoxFlagGetters(state) {
    // console.log(state.printPublicationTypeBoxFlag, 90);
    return state.printPublicationTypeBoxFlag;
  },
  getsearchBtnHit(state) {
    // console.log(state.printPublicationTypeBoxFlag, 90);
    return state.searchBtnFlag;
  },
  getofferOriginChanged(state) {
    // console.log(state.printPublicationTypeBoxFlag, 90);
    return state.offerOriginChanged;
  },
  getsocialNetworkNameBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.socialNetworkNameBoxFlag;
  },
  getCreditOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.isCreditOptionOn;
  },
  getBankingOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.isBankingOptionOn;
  },
  getUserSearchDateGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.userSearchDate;
  },
  getUserTimeGetters(state) {
    return state.userTime;
  },
  getAffinityBoxesGetters(state) {
    return state.affinityBoxesFlag;
  },
  getmediaAPIPayloadGetters(state) {
    return state.mediaAPIPayload;
  },
  getsectorAPIPayloadGetters(state) {
    return state.sectorAPIPayload;
  },
  getaudienceAPIPayloadGetters(state) {
    return state.audienceAPIPayload;
  },
  getsearchResultGetters(state) {
    return state.searchResult;
  },
  getsearchAPIBodyGetters(state) {
    return state.searchAPIBody;
  },
  getOldPageValueGetters(state) {
    return state.oldPageValue;
  },
  getocrFullTextPayloadGetters(state) {
    return state.ocrFullTextPayload;
  },
  getSnackbarFlagGetters(state) {
    return state.SnackbarFlag;
  },
  gettoMonthGetters(state) {
    return state.toMonth;
  },
  gettoDateGetters(state) {
    return state.toDate;
  },
  gettoYearGetters(state) {
    return state.toYear;
  },
  getmonthSelectionPayloadStateGetters(state) {
    return state.monthSelectionPayloadState;
  },
  getfromYearGetters(state) {
    return state.fromYear;
  },
  getfromMonthGetters(state) {
    return state.fromMonth;
  },
  getfromDateGetters(state) {
    return state.fromDate;
  },
  getcompanyDataGetters(state) {
    return state.companyData;
  },
  getaffinityDataGetters(state) {
    return state.affinityData;
  },
  getproductNameDataGetters(state) {
    return state.productNameData;
  },
  getDeliveryMethodPayloadGetters(state) {
    return state.DeliveryMethodPayload;
  },
  getgroupSizePayloadGetters(state) {
    return state.groupSizePayload;
  },
  getcommunicationTypeSelectionGetters(state) {
    return state.communicationTypeSelection;
  },
  getelectronicTypePayloadGetters(state) {
    return state.electronicTypePayload;
  },
  getPublicationTypePayloadGetters(state) {
    return state.PublicationTypePayload;
  },
  getPublicationNamePayloadGetters(state) {
    return state.PublicationNamePayload;
  },
  getPublicationNameSelectedGetters(state) {
    return state.PublicationNameSelected;
  },
  getproductCompaniesNamesGetters(state) {
    return state.productCompaniesNames;
  },
  getpersonalizedRadiosGetters(state) {
    return state.personalizedRadios;
  },
  getOldPaginationDataGetters(state) {
    return state.OldPaginationData;
  },
  getPanelistTextGetters(state) {
    return state.panelistText;
  },
  getPanelistTextRadiosGetters(state) {
    return state.panelistRadio;
  },
  getissueTypePayloadGetters(state) {
    return state.issueTypePayload;
  },
  getsocialPayloadGetters(state) {
    return state.socialPayload;
  },
  getnetworkNamePayloadGetters(state) {
    return state.networkNamePayload;
  },
  getintroductoryPricingPayloadGetters(state) {
    return state.introductoryPricingPayload;
  },
  getActionPayload(state) {
    return state.actionPayload;
  },
  getsearchDatePayloadGetters(state) {
    return state.searchDate;
  },
  getbetweenTimePayloadGetters(state) {
    return state.betweenTime;
  },
  getAndTimePayloadGetters(state) {
    return state.AndTime;
  },
  getsearchedBodyDataGetters(state) {
    return state.searchedBodyData;
  },
  getsearchBtnDisabledFlagGetters(state) {
    return state.searchBtnDisabledFlag;
  },
  getsectorAllGetters(state) {
    return state.sectorAll;
  },
  getmediaAllGetters(state) {
    return state.mediaAll;
  },
  getaudienceAllGetters(state) {
    return state.audienceAll;
  },
  getRawAdditionalGetters(state) {
    return state.raw_additional;
  },
  getpreviousPaginationFlagGetters(state) {
    return state.previousPaginationFlag;
  },
  getnextPaginationFlagGetters(state) {
    return state.nextPaginationFlag;
  },
  getlastPaginationFlagGetters(state) {
    return state.lastPaginationFlag;
  },
  getlastPageNoGetters(state) {
    return state.lastPageNo;
  },
  getSearchCriteria(state) {
    return state.searchCriteria;
  },
  getsearchResultOption(state) {
    return state.searchResultOption;
  },
  getlastResultFields(state) {
    return state.lastResultFields;
  },
  getSearchAgainFlag(state) {
    return state.SearchAgainFlag;
  },
  getOcrFullTextSearch(state) {
    return state.OcrFullTextSearch;
  },
  getsearchDateSelection(state) {
    return state.searchDateSelection;
  },
  getisAuthFlag(state) {
    return state.isAuthLogin;
  },
  getUpdatedRawDataGetter(state) {
    return state.roleUpdatedRawData;
  },
  getuserRawDataGetter(state) {
    return state.userRawData;
  },
  getsearchCriteriaGlobalGetter(state) {
    return state.searchCriteriaGlobal;
  },
  getmyexcelActivationGetter(state) {
    return state.myexcelActivation;
  },
};
